import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {
  StyledTableCell,
  StyledTableRow,
} from '../Timesheets/CustomStyles/StyledTable';
import { getHHMMSSFromSeconds } from '../../utils/TimeConversionFunctions';
import { Typography, Tooltip } from '@mui/material';
import { getUserData } from '../../services/UserService';

const WFHTimings = (props) => {
  const { taskData, userProjects } = props;
  const [approvers, setApprovers] = useState({});

  const handleForProjectName = (id) => {
    const filteredProject = userProjects.find((obj) => obj.projectId === id);
    return filteredProject?.projectName;
  };

  const fetchApprovers = async () => {
    const approversData = {};
    for (const task of taskData) {
      const approver = await getUserData(task.approverId);
      approversData[task.approverId] =
        approver.data?.firstName + ' ' + approver.data?.lastName;
    }
    setApprovers(approversData);
  };

  useEffect(() => {
    fetchApprovers();
  }, [taskData]);

  return (
    <>
      <Table size="small">
        <TableHead>
          <TableRow>
            <StyledTableCell style={{ backgroundColor: '#4d6cd9' }}>
              Date
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: '#4d6cd9' }}>
              Requested Hours
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: '#4d6cd9' }}>
              Approved Hours
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: '#4d6cd9' }}>
              Project
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: '#4d6cd9' }}>
              For Appraisal
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: '#4d6cd9' }}>
              Title
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: '#4d6cd9' }}>
              Description
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: '#4d6cd9' }}>
              Status
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: '#4d6cd9' }}>
              Approver
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {taskData.map((row) => (
            <StyledTableRow key={row.id}>
              <StyledTableCell component="th" scope="row">
                {row.dateOfWfh}
              </StyledTableCell>
              <StyledTableCell>
                {getHHMMSSFromSeconds(row.requestedWfhHours)}
              </StyledTableCell>
              <StyledTableCell>
                {row.status === 'APPROVED'
                  ? getHHMMSSFromSeconds(row.approvedWfhHours)
                  : '-'}
              </StyledTableCell>
              <StyledTableCell>
                {handleForProjectName(row.projectId)}
              </StyledTableCell>
              <StyledTableCell>
                {row.isAppraisal == true ? 'Yes' : 'No'}
              </StyledTableCell>
              <StyledTableCell>
                <Tooltip title={row.title || ''} arrow>
                  <Typography
                    sx={{
                      maxWidth: '12rem',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {row.title}
                  </Typography>
                </Tooltip>
              </StyledTableCell>
              <StyledTableCell size="small">
                <Tooltip title={row.description || ''} arrow>
                  <Typography
                    sx={{
                      maxWidth: '14rem',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {row.description}
                  </Typography>
                </Tooltip>
              </StyledTableCell>
              <StyledTableCell>{row.status}</StyledTableCell>
              <StyledTableCell>
                {approvers[row.approverId] || '-'}
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
};

export default WFHTimings;
